import React, { useState, useEffect } from "react";
import { Button, Upload, Col, Row, Modal, message, Radio } from "antd";
import { Moment } from "../../helpers";
import {
  UploadOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { AuthService, JobService } from "../../services";
import { API, Config } from "../../config";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("สามารถอัพโหลดไฟล์ JPG/PNG  เท่านั้น!");
  }
  const isLt2M = file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    message.error("รูปภาพต้องมีขนาดไม่เกิน 10MB!");
  }
  return isJpgOrPng && isLt2M;
}

const UPLOAD_TYPE_BEFORE = "informjob_before";
const UPLOAD_TYPE_AFTER = "informjob_after";

export const JobImageUpload = ({ jobId, visible, onUpload, onCancel }) => {
  const [refId, setRefId] = useState(jobId);
  const [imageBeforeUrl, setImageBeforeUrl] = useState("");
  const [imageAfterUrl, setImageAfterUrl] = useState("");
  const [loadingBefore, setLoadingBebore] = useState(false);
  const [loadingAfter, setLoadingAfter] = useState(false);
  const [uploadType, setUploadType] = useState("");

  useEffect(() => {}, []);

  const handleChangeBefore = (info) => {
    console.log("jobId", jobId);
    if (info.file.status === "uploading") {
      setLoadingBebore(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) => {
        setLoadingBebore(false);
        setImageBeforeUrl(imageUrl);
      });
    }
  };
  const handleChangeAfter = (info) => {
    console.log("jobId", jobId);
    if (info.file.status === "uploading") {
      setLoadingAfter(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) => {
        setLoadingAfter(false);
        setImageAfterUrl(imageUrl);
      });
    }
  };

  const resetForm = () => {
    setImageBeforeUrl("");
    setImageAfterUrl("");
    setLoadingBebore(false);
    setLoadingAfter(false);
  };

  const submit1 = ({ onSuccess, onError, file }) => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("model_type", UPLOAD_TYPE_BEFORE);
    formData.append("model_id", jobId);
    console.log("formdata", formData);
    JobService.upload(formData).then((rs) => {
      onUpload(rs.data.data);
      onSuccess(null, formData);
      message.success(rs.data.message);
    });
  };

  const submit2 = ({ onSuccess, onError, file }) => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("model_type", UPLOAD_TYPE_AFTER);
    formData.append("model_id", jobId);
    console.log("formdata", formData);
    JobService.upload(formData).then((rs) => {
      onUpload(rs.data.data);
      onSuccess(null, formData);
      message.success(rs.data.message);
    });
  };

  const uploadBeforeButton = (
    <div>
      {loadingBefore ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  const uploadAfterButton = (
    <div>
      {loadingAfter ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  return (
    <React.Fragment>
      <Modal
        open={visible}
        footer=""
        onCancel={() => {
          onCancel();
          resetForm();
        }}
      >
        <Row>
          <Col span={12}>
            <p>รูปก่อนทำการซ่อม</p>
            <Upload
              name="files"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              customRequest={submit1}
              beforeUpload={beforeUpload}
              onChange={handleChangeBefore}
              multiple={true}
            >
              {imageBeforeUrl ? (
                <img
                  src={imageBeforeUrl}
                  alt="avatar"
                  style={{ width: "100%" }}
                />
              ) : (
                uploadBeforeButton
              )}
            </Upload>
          </Col>
          <Col span={12}>
            <p>รูปภาพหลังซ่อม</p>
            <Upload
              name="imgAfter"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              customRequest={submit2}
              beforeUpload={beforeUpload}
              onChange={handleChangeAfter}
              multiple={true}
            >
              {imageAfterUrl ? (
                <img
                  src={imageAfterUrl}
                  alt="avatar"
                  style={{ width: "100%" }}
                />
              ) : (
                uploadAfterButton
              )}
            </Upload>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};
